import { AttachmentFile, RawAttachmentFile } from "ts/api/attachmentFile";
import { FormAttachmentsResponseCell, GridFormCellType } from "ts/api/task";
import parsePath from "parse-filepath";
import { fileTypesItems } from "view/apps/Organiser/pages/Show/OnlineManual/components/TaskDetailsDrawer/helpers/fileTypesItems";

export const isAttachmentRaw = (
  attachment: RawAttachmentFile | AttachmentFile
): attachment is RawAttachmentFile =>
  !attachment.url && attachment.file instanceof File;

export const groupAttachments = (
  files: FormAttachmentsResponseCell["attachments"]
) =>
  files.reduce<[RawAttachmentFile[], AttachmentFile[]]>(
    ([rawAcc, attachmentsAcc], file) => {
      if (isAttachmentRaw(file)) {
        rawAcc.push(file as RawAttachmentFile);
      } else {
        attachmentsAcc.push(file as AttachmentFile);
      }
      return [rawAcc, attachmentsAcc];
    },
    [[], []]
  );
export const isValueAttachment = (
  value: GridFormCellType
): value is FormAttachmentsResponseCell => {
  if (!value) {
    return false;
  }
  return value.type === "attachments" && !!value.attachments?.length;
};

const DEFAULT_FORMATS = fileTypesItems.map(({ value }) => value);

export const flattenFileFormats = (fileFormats = DEFAULT_FORMATS) =>
  fileFormats.flatMap((format) => format.split(/,\s+/g));

export const isValidFileFormat = (file: File, supportedFormats: string[]) => {
  const { ext } = parsePath(file.name);
  return supportedFormats.includes(ext);
};
